import { FlatList, ListRenderItemInfo, StyleSheet } from 'react-native';
import { mvs } from 'react-native-size-matters';

import { SongHistoryCard } from './SongHistoryCard';
import { isTablet } from '../../constants';
import { SongHistoryEntry } from '../../models';

interface SongHistoryListProps {
  songs: SongHistoryEntry[];
  onSongPress?: (song: SongHistoryEntry) => void;
}

export const SongHistoryList = ({ songs, onSongPress }: SongHistoryListProps) => {
  const renderItem = ({ item }: ListRenderItemInfo<SongHistoryEntry>) => (
    <SongHistoryCard
      song={item}
      onPress={onSongPress ? () => onSongPress(item) : undefined}
      style={isTablet ? styles.cardTablet : undefined}
    />
  );

  const keyExtractor = (item: SongHistoryEntry, index: number) =>
    `${item.title}-${item.artist}-${index}`;

  return (
    <FlatList
      data={songs}
      renderItem={renderItem}
      keyExtractor={keyExtractor}
      contentContainerStyle={styles.listContent}
      style={styles.container}
      showsVerticalScrollIndicator={false}
      numColumns={isTablet ? 2 : 1}
      key={isTablet ? 'two-columns' : 'one-column'}
      columnWrapperStyle={isTablet ? styles.columnWrapper : undefined}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: mvs(24),
  },
  listContent: {
    gap: mvs(4),
    paddingBottom: mvs(24),
  },
  columnWrapper: {
    gap: mvs(24),
  },
  cardTablet: {
    flex: 1,
  },
});
